/**
 * Created on 2020/11/30.
 * @description api列表，API方法以fetch开头
 * api接口请按业务功能按模块划分(不要按页面划分)，然后在此处引入
 */
import BaseApi from './modules/base';
import MonitorApi from './modules/monitor';

export default {
  ...BaseApi,
  ...MonitorApi
};
